// extracted by mini-css-extract-plugin
module.exports = {"Block":"src-components-Main-Infos-Block-Block--1bVOa"};